import classes from '../../css/success.module.scss';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Proyectos = () => {
    return (
        <div>
             <Helmet><title>Backend Helpers Limited | success-stories </title></Helmet>
            <main className={classes['main-content']}>
    	<section id="projects" className={`${classes['container-s']} ${classes.projects}`}>
    		 <div  className={`${classes['project-card-border']} ${classes['mr-2']}`}>
                <div className={classes['project-card']}>
                    <h2 className={classes['project-card-title']}>Infraestructura  <br /> AWS  AZFA</h2>
                    <button type="button" className={classes['project-btn']}><Link to="./aws-azfa" >Ver mas </Link></button>
                </div>
             </div>
             <div  className={classes['project-card-border']}>
                <div className={classes['project-card']}>
                    <h2 className={classes['project-card-title']}>EcoRolling <br /> Arquitectura AWS serverless</h2>
                    <button type="button" className={classes['project-btn']}> <Link to="./ecorolling"> Ver mas </Link></button>
                </div>
             </div>
    	</section>
    </main>
        
        </div>
    );
};

export default Proyectos;